import {FC, SVGProps} from 'react';

export const ConfirmationQuestionIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="72"
		height="88"
		viewBox="0 0 72 88"
		fill="none"
		aria-hidden
		{...props}
	>
		<path
			d="M41.4439 0C41.3851 0 41.3165 0 41.2577 0H30.6543C39.2585 0.0294446 47.0396 3.64131 52.5765 9.42226C52.6059 9.4517 52.6353 9.49096 52.6745 9.52041C53.6741 10.5706 54.5952 11.6993 55.438 12.8771C55.487 12.9458 55.536 13.0145 55.585 13.0832C55.9966 13.6721 56.3886 14.2708 56.761 14.8891C56.7708 14.9088 56.7806 14.9284 56.8002 14.948C57.153 15.5369 57.4764 16.1356 57.79 16.7441C57.839 16.8423 57.888 16.9306 57.937 17.0288C58.2408 17.6471 58.5348 18.2851 58.7994 18.9329C58.8386 19.031 58.8778 19.1193 58.917 19.2175C59.1522 19.8064 59.3677 20.3953 59.5637 20.994C59.5931 21.0921 59.6323 21.2001 59.6715 21.2982C59.8773 21.9558 60.0635 22.6134 60.2301 23.2906C60.2693 23.4281 60.2987 23.5753 60.3281 23.7127C60.4751 24.331 60.5927 24.9592 60.7005 25.5971C60.7103 25.6757 60.7299 25.7542 60.7397 25.8425C60.8475 26.5295 60.9259 27.2264 60.9847 27.9331C60.9945 28.0999 61.0141 28.2668 61.0239 28.4336C61.0729 29.1501 61.1121 29.8666 61.1121 30.5929C61.1121 46.3457 49.1759 59.3504 33.8882 61.0189V67.006H44.7758V61.0189C60.0635 59.3504 71.9997 46.3457 71.9997 30.5929C71.9997 13.731 58.2898 0 41.4439 0Z"
			fill="black"
		/>
		<path
			d="M32.5173 75.5944V86.5085H20.6693V75.5944H32.5173ZM34.0068 74.1025H19.1699V88.0004H34.0068V74.1025Z"
			fill="black"
		/>
		<path
			d="M14.8359 30.6024H25.7235C25.7235 23.84 30.0844 18.0394 36.0721 15.8212C34.3768 15.1931 32.4756 14.8594 30.5548 14.8594C21.882 14.8594 14.8359 21.9163 14.8359 30.6024Z"
			fill="black"
		/>
		<path d="M30.0566 74.1025H34.006V88.0004H44.8936V74.1025H30.0566Z" fill="black" />
		<path
			d="M30.5558 1.49186C46.5785 1.49186 59.6221 14.5456 59.6221 30.6027C59.6221 45.4918 48.4895 57.9273 33.731 59.5369L32.3982 59.6841V65.5141H20.5502V47.8376H30.5656C40.0518 47.8376 47.7741 40.1035 47.7741 30.6027C47.7741 21.1019 40.0518 13.3678 30.5656 13.3678C21.5792 13.3678 14.1803 20.3069 13.4159 29.1109H1.52877C2.30296 13.7506 15.0329 1.49186 30.5558 1.49186ZM30.5558 0C13.7099 0 0 13.731 0 30.6027H14.8369C14.8369 21.9166 21.8928 14.8597 30.5558 14.8597C39.2189 14.8597 46.2747 21.9264 46.2747 30.6027C46.2747 39.279 39.2189 46.3457 30.5558 46.3457H19.0508V67.006H33.8878V61.0189C49.1755 59.3504 61.1116 46.3457 61.1116 30.6027C61.1116 13.731 47.4017 0 30.5558 0Z"
			fill="black"
		/>
	</svg>
);
